export default {
  'commons.table.loadMore': 'Load More',
  'commons.noData': 'No data.',
  'commons.form.loading': 'Loading',
  'commons.form.button.clean': 'Clean',
  'commons.form.button.close': 'Close',
  'commons.form.button.save': 'Save',
  'commons.form.button.remove': 'Delete',
  'commons.form.button.search': 'Search',
  'commons.form.errors.requiredField': 'This form field is required.',
  'commons.form.errors.invalidField': 'This form field is invalid.',
  'commons.form.errors.maxLength':
    'This field must have at most {max} characters',
  'commons.form.errors.minLength':
    'This field must be at least {min} characters',
  'commons.form.errors.percentageField':
    'The informed value is not a valid percentage.',
  'commons.form.errors.percentageField.min': 'Minimum percentage 0%.',
  'commons.form.errors.percentageField.max': 'Maximum percentage 1000%.',
  'commons.form.error.validNumberField': 'Invalid number',
  'commons.form.errors.requiredNcm': 'The NCM field is required.',
  'commons.form.errors.requiredCest': 'The CEST field is required.',
  'commons.form.errors.requiredCpf': 'The CPF field is required.',
  'commons.form.errors.requiredRg': 'The RG field is required.',
  'commons.form.errors.requiredDate': 'The date field is required.',
  'commons.form.errors.requiredCep': 'The CEP field is required.',
  'commons.form.errors.requiredCnpj': 'The CNPJ field is required.',
  'commons.form.errors.requiredLicensePlate':
    'The License Plate field is required.',
  'commons.form.errors.invalidNcm': 'The NCM field is invalid.',
  'commons.form.errors.invalidCest': 'The CEST field is invalid.',
  'commons.form.errors.invalidCpf': 'The CEP field is invalid.',
  'commons.form.errors.invalidRg': 'The RG field is invalid.',
  'commons.form.errors.invalidDate': 'The date field is invalid.',
  'commons.form.errors.invalidCep': 'The CEP field is invalid.',
  'commons.form.errors.invalidCnpj': 'The CNPJ field is invalid.',
  'commons.form.errors.invalidEmail': 'The e-mail field is invalid.',
  'commons.form.errors.invalidUrl': 'The website field is invalid.',
  'commons.form.errors.invalidLicensePlate':
    'The license plate field is invalid.',
  'commons.form.notification.error': 'The form request failed.',
  'commons.form.notification.errorDescription':
    'The application server could not be reached.',
  'commons.form.message.error': 'Fill in all mandatory fields',
  'commons.list.filter.order': 'Order',
  'commons.list.filter.asc': 'Ascedent',
  'commons.list.filter.desc': 'Descendent',
  'commons.list.header.action': 'Action',
  'commons.list.action.button.clock': 'Schedules',
  'commons.list.action.button': 'View/Edit',
  'commons.list.action.button.view': 'View',
  'commons.list.action.button.remove': 'Remove',
  'commons.list.action.button.delete': 'Delete',
  'commons.list.action.button.enable': 'Enable',
  'commons.list.action.button.disable': 'Disable',
  'commons.list.action.button.replicate': 'Replicate',
  'commons.page.button.generateReport': 'Generate Report',
  'commons.page.button.generateBudget': 'Generate Budget',
  'commons.page.button.checklist': 'Checklist',
  'commons.report.modal.title': 'Generate Report',
  'commons.report.modal.message.success': 'Report generated successfully!',
  'commons.report.modal.message.error': 'Unable to generate report!',
  'commons.report.form.description': 'Description',
  'commons.report.form.type': 'Type Export',
  'commons.report.form.type.view': 'View Only',
  'commons.report.form.type.pdf': 'PDF',
  'commons.report.form.type.spreadsheet': 'Spreadsheet',
  'commons.report.form.button.export': 'Export',
  'commons.report.form.button.print': 'Print',
  'commons.modal.button.cancel': 'Cancel',
  'commons.modal.button.next': 'Next',
  'commons.modal.button.back': 'Back',
  'commons.modal.button.save': 'Save',
  'commons.modal.contact.title': 'New Contact',
  'commons.modal.contact.form.name': 'Name',
  'commons.modal.contact.form.department': 'Department',
  'commons.modal.contact.form.birthDate': 'Birth Date',
  'commons.modal.contact.form.email': 'Email',
  'commons.modal.contact.form.gender': 'Gender',
  'commons.modal.contact.form.gender.male': 'Male',
  'commons.modal.contact.form.gender.female': 'Female',
  'commons.modal.contact.form.receiveEmail': 'Receive Email?',
  'commons.modal.contact.form.receiveEmail.true': 'Yes',
  'commons.modal.contact.form.receiveEmail.false': 'No',
  'commons.modal.contact.form.details.title': 'Details',
  'commons.modal.contact.form.contactList.status': 'Status',
  'commons.modal.contact.form.contactList.status.active': 'Active',
  'commons.modal.contact.form.contactList.status.inactive': 'Inactive',
  'commons.modal.contact.form.contactList.contactType': 'Type',
  'commons.modal.contact.form.contactList.contactType.email': 'Email',
  'commons.modal.contact.form.contactList.contactType.mobile': 'Mobile',
  'commons.modal.contact.form.contactList.contactType.fax': 'Fax',
  'commons.modal.contact.form.contactList.contactType.phone': 'Phone',
  'commons.modal.contact.form.contactList.contactType.whatsapp': 'Whatsapp',
  'commons.modal.contact.form.contactList.value': 'Value',
  'commons.modal.contact.form.contactList.description': 'Description',
  'commons.modal.contact.form.contactList.addItem': 'Add Item',
  'commons.modal.contact.added.message': 'Contact added',
  'commons.modal.contact.added.description':
    'The contact has been successfully added!',
  'commons.modal.contact.removed.message': 'Contact removed',
  'commons.modal.contact.removed.description':
    'The contact has been successfully removed!',
  'commons.modal.contact.updated.message': 'Contact updated',
  'commons.modal.contact.updated.description':
    'The contact has been successfully updated!',

  'commons.modal.address.added.message': 'Address added',
  'commons.modal.address.added.description':
    'The address has been successfully added!',
  'commons.modal.address.removed.message': 'Address removed',
  'commons.modal.address.removed.description':
    'The address has been successfully removed!',
  'commons.modal.address.updated.message': 'Address updated',
  'commons.modal.address.updated.description':
    'The address has been successfully updated!',

  'commons.address.remove.confirm.title': 'Remove address',
  'commons.address.remove.confirm.content':
    'Would you like to remove the selected address?',

  'commons.report.view': 'View',
  'commons.report.viewPDF': 'View PDF',

  'commons.entity.save': 'Save',
  'commons.entity.create': 'Create',
  'commons.entity.add': 'Add',
  'commons.entity.update': 'Update',
  'commons.entity.remove': 'Remove',
  'commons.entity.view': 'View',
  'commons.entity.search': 'Search',
  'commons.entity.edit': 'Edit',
  'commons.entity.viewEdit': 'View/Edit',
  'commons.entity.viewAll': 'View All',
  'commons.entity.report': 'Report',
  'commons.entity.situation': 'Situation',
  'commons.entity.status': 'Status',
  'commons.entity.active': 'Active',
  'commons.entity.inactive': 'Inactive',
  'commons.entity.value': 'Value',
  'commons.entity.percent': 'Percent',
  'commons.entity.send': 'Send',
  'commons.entity.help': 'Help',
  'commons.entity.notifications': 'Notifications',
  'commons.entity.user': 'User',
  'commons.entity.settings': 'Settings',
  'commons.entity.total': 'Total',

  'commons.message.info.mobileTable':
    'For best viewing of tables, use the device horizontally.',

  'commons.errors.generic.message': 'Error',
  'commons.errors.generic.description': 'The server was unavailable.',

  'commons.errors.notFound': '{content} not found!',

  'commons.errors.form.message': 'Warning',
  'commons.errors.form.description': 'Enter the form fields',

  'commons.archive.upload.message': 'Success',
  'commons.archive.upload.description': 'File uploaded.',

  'commons.archive.upload.error.message': 'Failed to upload file',
  'commons.archive.upload.error.description':
    'Sorry, it was not possible to send the file to the server.',

  'commons.address': 'Address',
  'commons.address.cep': 'CEP',
  'commons.address.uf': 'UF',
  'commons.address.city': 'City',
  'commons.address.district': 'District',
  'commons.address.street': 'Street',
  'commons.address.number': 'Number',
  'commons.address.complement': 'Complement',

  'commons.contact': 'Contact',
  'commons.contacts': 'Contacts',
  'commons.contact.contactType': 'Contact Type',
  'commons.contact.contactType.email': 'E-Mail',
  'commons.contact.contactType.mobile': 'Mobile',
  'commons.contact.contactType.fax': 'Fax',
  'commons.contact.contactType.phone': 'Phone',
  'commons.contact.contactType.whatsapp': 'WhatsApp',
  'commons.contact.contactType.foreign': 'Foreign',
  'commons.contact.name': 'Name',
  'commons.contact.value': 'Contact',

  'commons.others': 'Others',

  'commons.options.yes': 'Yes',
  'commons.options.no': 'No',

  'commons.date.weekdays.monday': 'Monday',
  'commons.date.weekdays.tuesday': 'Tuesday',
  'commons.date.weekdays.wednesday': 'Wednesday',
  'commons.date.weekdays.thursday': 'Thursday',
  'commons.date.weekdays.friday': 'Friday',
  'commons.date.weekdays.saturday': 'Saturday',
  'commons.date.weekdays.sunday': 'Sunday',

  'commons.clear.filters': 'Clear Filters',

  'reports.form.selectTheDesiredMonth': 'Select the desired month',
  'reports.form.in': 'In:',
  'reports.form.from': 'From:',
  'reports.form.orSelectTheDesiredMonth': 'Or select the desired month',
  'reports.form.companies': 'Companies',
  'reports.button.viewReport': 'View Report',
  'reports.button.pdf': 'Generate PDF',
  'reports.button.viewReport': 'Generate CSV',

  'commons.table.column.workOrder': 'Budget',
  'commons.table.column.description': 'Description',
  'commons.table.column.manufacturerCode': 'Manufacturer Code',
  'commons.table.column.licensePlate': 'License Plate',
  'commons.table.column.qtyRequested': 'Qty. Requested',
};
